export const bardiTypes = {
    loading: "LOADING_BARDI",
    delete: "DELETE_BARDI",
    loadedOne: "LOADED_BARDI",
    loadedMultiple: "LOADED_BARDIS",
    success: "SUCCESS_BARDI",
    restore: "RESTORE_BARDI",
    hardDelete: "HARDDELETE_BARDI",
};
